import * as React from 'react';
import * as L from 'leaflet';
import { MapConsumer, MapContainer, ScaleControl, useMapEvents } from 'react-leaflet';

import { RainbowGradient } from '../../helpers';
import { ClusteredMarker } from './ClusteredMarker';
import { StandardLayerControl } from './StandardLayerControl';

interface IMapElement {
  count?: number;
  latitude: number;
  longitude: number;
}

interface IProps {
  /**
   * List of marker locations to display:
   */
  elements: IMapElement[];
  /**
   * Callback for when map is moved/zoomed:
   */
  onChange: (bounds: L.LatLngBounds, zoom: number) => void; 
  /**
   * When this random number changes, the map
   * will execute onChange.
   */
  time: number;
  /**
   * Callback that produces popup content for a marker.
   */
  popup: (item: IMapElement) => React.ReactNode;
}

class MarkerGroup extends React.Component<{map: L.Map} & IProps> {
  constructor(props: {map: L.Map} & IProps) {
    super(props);
  }

  /* zoomToBounds = (): void => {
    let p = this.props;
    if(p.locations.length == 0) return;
    let bounds = new L.LatLngBounds([p.locations[0].lat, p.locations[0].lng], [p.locations[0].lat, p.locations[0].lng]);
    this.props.locations.forEach((loc: L.LatLngLiteral) => {
      bounds = bounds.extend([loc.lat, loc.lng]);
    });
    p.map.fitBounds(bounds);
  } */

  componentDidMount = () => {
    // Load initial map data.
    this.props.onChange(new L.LatLngBounds({ lat: 85, lng: -175}, {lat: -85, lng: 175}), 0);
  }

  componentDidUpdate = (prev: IProps) => {
    // The random time has updated, which means that a parent component
    // has updated its query. Tell the parent to fetch new results.
    if(prev.time != this.props.time) {
      this.props.onChange(this.props.map.getBounds(), this.props.map.getZoom());
    }
  }  

  render() {
    return this.props.elements.map((elem: IMapElement, idx: number) => 
      <ClusteredMarker key={idx} gradient={RainbowGradient} data={elem} popup={this.props.popup}/>
    );
  }
}

const Events = (props: {onChange: (bounds: L.LatLngBounds, zoom: number) => void}): null => {
  // Register for events:
  const map: L.Map = useMapEvents({
    load: () => dispatch(map, "load"),
    resize: () => dispatch(map, "resize"),
    zoomend: () => dispatch(map, "zoomend"),
    moveend: () => dispatch(map, "moveend")
  });
  // Dispatch an event:
  const dispatch = (map: L.Map, event: string) => {
    props.onChange(map.getBounds(), map.getZoom());
  }    
  return null;
}

class MarkersMap extends React.Component<IProps> {
  render() {
    let p = this.props;
    return (
      <MapContainer 
        style={{ height: '100%', width: '100%' }} 
        center={[0, 0]} 
        zoom={2} 
        scrollWheelZoom={true} 
        attributionControl={false}
      >
        <StandardLayerControl/>
        <ScaleControl position="topleft" imperial={false}/>
        {/* MapConsumer is used to pass map instance down to subcomponents: */}
        <MapConsumer> 
          {(map) => <>
            <MarkerGroup map={map} {...p}/>
            <Events onChange={p.onChange}/>
          </>}
        </MapConsumer>
      </MapContainer>
    );
  }
}

export { MarkersMap, IMapElement };